import { render, staticRenderFns } from "./NewsandEvents.vue?vue&type=template&id=f65a68e0&"
import script from "./NewsandEvents.vue?vue&type=script&lang=js&"
export * from "./NewsandEvents.vue?vue&type=script&lang=js&"
import style0 from "./NewsandEvents.vue?vue&type=style&index=0&id=f65a68e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports